import * as THREE from 'three'
import { toPoints } from 'svg-points'
import { Bezier } from 'bezier-js'

function pathToPoints(pathStr) {
    const points = toPoints({ type: 'path', d: pathStr })

    return points.reduce((acc, curr, i) => {
        if (curr.curve) {
            const prev = points[i - 1]
            const curve = new Bezier(
                prev.x,
                prev.y,
                curr.curve.x1,
                curr.curve.y1,
                curr.curve.x2,
                curr.curve.y2,
                curr.x,
                curr.y
            )
            const newPoints = curve.getLUT(20)
            const newAcc = [...acc, ...newPoints]
            return newAcc
        }

        acc.push(curr)
        return acc
    }, [])
}
//
export default function TransformSVGPath2(d, hasTransform) {
    let points = pathToPoints(d)

    const path = new THREE.Shape()

    // transform="matrix(.98 0 0 -.98 250 420)
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#matrix
    if (hasTransform) {
        points = points.map((point) => ({
            ...point,
            x: 0.98 * point.x + 250,
            y: -0.98 * point.y + 420,
        }))
    }

    points.forEach((point) => {
        // This the transforms found in https://github.mlbam.net/site-baseball-savant/basesite/pull/310
        if (point.moveTo) {
            path.moveTo((point.x - 125) * 2.42, (point.y - 202) * -2.42)
        }
        path.lineTo((point.x - 125) * 2.42, (point.y - 202) * -2.42)
    })

    return path
}
